import { render, staticRenderFns } from "./OrgContactAssign.vue?vue&type=template&id=0dc2756b"
import script from "./OrgContactAssign.vue?vue&type=script&lang=js"
export * from "./OrgContactAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports